import { useState, useEffect } from "react";
import { getAllCategories } from "../services/categoryService"; // ✅ Import API
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles
import "../styles/quill-custom.css"; // ✅ Custom styles for fonts

const AddNewsComp = ({ onSubmit, loading }) => {
  const [formData, setFormData] = useState({
    Title: "",
    Description: "", // Store rich text
    ImageBase64: "",
    ImageFileName: "",
    ImageAltText: "",
    CategoryId: "",
    Subtitle : "",
    Meta : "",
    Language : "",
    Slug : "",
    
  });

  const [categories, setCategories] = useState([]); // Store categories

  useEffect(() => {
    const fetchCategories = async () => {
      const data = await getAllCategories();
      if (data.success) {
        setCategories(data.categories);
      }
    };
    fetchCategories();
  }, []);

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (type === "file") {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          const base64String = reader.result.split(",")[1]; // Extract base64 only
          setFormData((prevData) => ({
            ...prevData,
            ImageBase64: base64String,
            ImageFileName: file.name,
          }));
        };
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // Handle rich text editor change
  const handleDescriptionChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      Description: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  // Quill Modules with Font Selection
  const modules = {
    toolbar: [
      [{ font: ["sans-serif", "serif", "monospace", "roboto", "montserrat"] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ],
  };  

  const formats = [
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "align",
    "list",
    "bullet",
    "link",
    "image",
  ];

  return (
    <div className="contact">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-12">
            <div className="contact-form">
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="Title"
                      placeholder="Title"
                      required
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <select
                      className="form-control"
                      name="CategoryId"
                      required
                      onChange={handleChange}
                    >
                      <option value="">Select Category</option>
                      {categories.map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="Subtitle"
                      placeholder="Subtitle"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="Meta"
                      placeholder="Meta"
                      required
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="Language"
                      placeholder="Language"
                      required
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="Slug"
                      placeholder="Slug"
                      required
                      onChange={handleChange}
                    />
                  </div>
                </div>


                {/* React Quill for Rich Text Editing with Fonts */}
                <div className="form-group">
                  <label>Description</label>
                  <ReactQuill
                    theme="snow"
                    value={formData.Description}
                    onChange={handleDescriptionChange}
                    modules={modules}
                    formats={formats}
                  />
                </div>

                <div className="form-group">
                  <input
                    type="file"
                    className="form-control-file"
                    name="ImageFile"
                    accept="image/*"
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="ImageAltText"
                      placeholder="ImageAltText"
                      required
                      onChange={handleChange}
                    />
                  </div>
                  

                <div>
                  <button className="btn" type="submit" disabled={loading}>
                    {loading ? "Adding..." : "Add News"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewsComp;
